
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { getChild } from '../reducer';
import {
	fetchPayment, PaymentTypes,
	PAYMENT_FETCH_REQUEST, PAYMENT_FETCH_SUCCESS, PAYMENT_FETCH_FAILURE
} from '../payments/actions';
import { withTranslation, Trans } from 'react-i18next';
import moment from 'moment';
import ReduxBlockUi from 'react-block-ui/redux';
import 'react-block-ui/style.css';
import FontAwesome from 'react-fontawesome';
import { i18n } from '../../common/services/globalize';
import analyticsTracker, { AnalyticsPlatforms } from '../../common/services/analyticsTracker';

class Complete extends Component {

	componentDidMount() {
		const { match, paymentType, fetchPayment } = this.props;
		if (match.params.id) {
			const paymentId = Number(match.params.id);
			fetchPayment(paymentId, paymentType);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.payment && nextProps.payment && nextProps.payment.isProcessed && nextProps.payment.statusId !== 3) {
			this.trackPurchaseAnalytics(nextProps);
		}
	}

	trackPurchaseAnalytics({ payment, paymentType, franchisorCurrency }) {
		const paymentId = payment.id;
		const storageKey = `analytics_tracked_${paymentId}`;
		if (sessionStorage.getItem(storageKey)) {
			return;
		}

		let itemId, itemName, itemBrand, itemCategory;
		switch (paymentType) {
			case PaymentTypes.Lesson:
				if (payment.lesson) {
					itemId = payment.lesson.grade && payment.lesson.grade.id;
					itemName = payment.lesson.grade && payment.lesson.grade.name;
					itemBrand = payment.lesson.center && payment.lesson.center.name;
					itemCategory = payment.lesson.term && `${payment.lesson.term.name}, ${payment.lesson.term.schoolYear}`;
				}
				break;
			case PaymentTypes.Workshop:
				itemId = `Workshop_${payment.workshopId}`;
				itemName = payment.workshop;
				itemBrand = payment.center && payment.center.name;
				itemCategory = 'Workshop';
				break;
			case PaymentTypes.IndividualConsultation:
				itemId = `Individual_Consultation_${payment.consultationType}`;
				itemName = payment.consultationType;
				itemBrand = payment.center && payment.center.name;
				itemCategory = 'Individual_Consultation';
				break;
		}

		const eventIdStr = String(paymentId);

		const fbEventData = {
			currency: franchisorCurrency,
			value: payment.totalAmount,
			contents: [{ id: itemId, quantity: payment.quantity }],
			content_name: itemName,
			num_items: payment.quantity
		};

		const gaEventData = {
			transaction_id: paymentId,
			value: payment.totalAmount,
			currency: franchisorCurrency,
			tax: payment.taxAmount,
			shipping: 0,
			items: [{
				affiliation: 'Booking Autopilot',
				item_id: itemId,
				item_name: itemName,
				item_brand: itemBrand,
				item_category: itemCategory,
				quantity: payment.quantity,
				price: payment.unitPriceAmount
			}]
		};

		if (payment.promoCodes && payment.promoCodes.length > 0) {
			gaEventData.items[0].coupon = payment.promoCodes[0];
		}

		const isTrial = payment.paymentType === 'Trial';

		analyticsTracker.trackEvent('CompletedBooking', fbEventData, AnalyticsPlatforms.FacebookPixel, true, eventIdStr);
		analyticsTracker.trackEvent(isTrial ? 'StartTrial' : 'Purchase', fbEventData, AnalyticsPlatforms.FacebookPixel, isTrial, eventIdStr);
		analyticsTracker.trackEvent('purchase', gaEventData, AnalyticsPlatforms.GoogleAnalytics);

		sessionStorage.setItem(storageKey, '1');
	}

	renderMessage() {
		const { success, errorMessage, successMessage, paymentType, match, t } = this.props;
		const routeParams = match.params;

		if (!success) {
			let notCompletedMessageResource = 'FO_Booking_NotCompleted';
			let backPath = '';
			switch (paymentType) {
				case PaymentTypes.Lesson:
					notCompletedMessageResource = 'FO_Booking_NotCompleted';
					backPath = '/booking/center';
					break;
				case PaymentTypes.IndividualConsultation:
					notCompletedMessageResource = 'FO_Booking_IndividualConsultation_NotCompleted';
					backPath = '/individual-consultation/booking';
					break;
				case PaymentTypes.Workshop:
					notCompletedMessageResource = 'FO_Booking_Workshop_NotCompleted';
					backPath = routeParams && routeParams.centerId && routeParams.workshopId && `/workshop/booking/${routeParams.centerId}/${routeParams.workshopId}/class`;
					break;
			}

			return <div>
				<Alert bsStyle='danger'>
					<div>{errorMessage}</div>
					<div>{t(notCompletedMessageResource)}</div>
				</Alert>
				<Link to={backPath} className='btn btn-back'><FontAwesome name='arrow-circle-left' /> {t('Common_Back')}</Link>
			</div>;
		}
		if (success && successMessage) {
			return <Alert bsStyle='success'>{successMessage}</Alert>;
		}
		return <div />;
	}

	renderPaymentDetails() {
		const { paymentType, payment, parent, franchisor, match, t } = this.props;
		const { paymentMethod } = payment;

		let paymentFinalizeDescriptionHtml = '';
		if (paymentMethod) {
			const ibanPrefix = franchisor.isIbanBankTransfer && paymentMethod.name === 'BankTransfer' ? 'Iban_' : '';
			const finalizePaymentResourceKey = `FO_PaymentMethod_${paymentMethod.name}_${ibanPrefix}FinalizePayment`;
			const finalizePaymentInstalmentResourceKey = `${finalizePaymentResourceKey}_Instalment`;

			if (payment.isInstalmentPayment && payment.instalmentPlan) {
				payment.instalmentPlan.startDateFormatted = moment(payment.instalmentPlan.startDate).format('ll');
				payment.instalmentPlan.intervalFormatted = t(`RecurrenceType_${payment.instalmentPlan.intervalType.name}_Description`, { count: payment.instalmentPlan.intervalLength });
			}

			paymentFinalizeDescriptionHtml = t(payment.isInstalmentPayment && i18n.exists(finalizePaymentInstalmentResourceKey) ? finalizePaymentInstalmentResourceKey : finalizePaymentResourceKey, payment);
		}

		const paymentId = payment.id;
		const paymentHistoryLink = `/payment-history/${paymentId}/${paymentType}`;
		const email = parent.email;
		const centerEmail = payment && payment.center && payment.center.email;
		const centerPhoneNumber = payment && payment.center && payment.center.phoneNumber;

		let enrolAnotherChildLink = `/booking/child?add=${parent.children.length <= 1}&reset=true`;
		switch (paymentType) {
			case PaymentTypes.Workshop:
				enrolAnotherChildLink = `/workshop/booking/${match.params.centerId}/${match.params.workshopId}/child?add=${parent.children.length <= 1}&reset=true`
				break;
		}

		return <div style={{ fontSize: '16px' }}>
			{/* payment is Paid or there are no user instructions for finalizing the payment (ePay/Saferpay/CloverConnect status is Pending until provider sends webhook notification) */}
			{((payment.statusId !== 1 && payment.statusId !== 6) || !paymentFinalizeDescriptionHtml) && <div>
				<div className='steps_title'>{t('FO_PageTitle_Parent_BookingComplete')}</div>
				<div>
					<Trans i18nKey='FO_Booking_Success'>
						Your order <Link to={paymentHistoryLink} style={{ color: '#1d93d1', fontWeight: 'bold' }}>{{ paymentId }}</Link> was completed successfully.
					</Trans>
				</div>
				<Trans i18nKey='FO_Booking_SuccessDescription'>
					Order details will be sent to your registered email {{ email }}.
				</Trans>
			</div>
			}
			{/* payment is Pending and user needs to take action to finalize the payment (BankTransfer/Easypay) */}
			{(payment.statusId === 1 || payment.statusId === 6) && paymentFinalizeDescriptionHtml && <div style={{ marginTop: '10px' }}>
				<div className='steps_title'>
					<Trans i18nKey='FO_Booking_PendingPayment'>
						Order #<Link to={paymentHistoryLink} style={{ color: '#1d93d1', fontWeight: 'bold' }}>{{ paymentId }}</Link> waiting for payment!
					</Trans>
				</div>
				{paymentType === PaymentTypes.Lesson && <div>
					<div><b>{t('FO_Booking_PendingPaymentDescription')}</b></div>
					<div style={{ marginTop: '10px' }}><b><u>{t('FO_Booking_OrderDetails')}</u></b></div>
					<div>{t('FO_Payment_Child')}: {payment.child && payment.child.fullName}</div>
					<div>{t('FO_Payment_Grade')}: {payment.lesson.name || (payment.lesson.grade && payment.lesson.grade.name)}</div>
					<div>{t('FO_Booking_OrderDetails_Date')}: {moment(payment.startDate).format('ll')}</div>
					<div>{t('FO_Booking_OrderDetails_Quantity')}: {payment.quantity}</div>
				</div>}

				<div style={{ marginTop: '10px' }} dangerouslySetInnerHTML={{ __html: paymentFinalizeDescriptionHtml }} />
			</div>}
			{/* show Direct Debit setup confirmation for GoCardless */}
			{payment.statusId === 2 && payment.isInstalmentPayment && paymentFinalizeDescriptionHtml && <div style={{ marginTop: '10px' }} dangerouslySetInnerHTML={{ __html: paymentFinalizeDescriptionHtml }} />}
			<div style={{ marginTop: '10px' }}>{t('FO_Booking_Assistance', { email: franchisor.companyEmail, centerEmail: centerEmail, centerPhoneNumber: centerPhoneNumber })}</div>
			<div style={{ marginTop: '10px' }}>
				<Trans i18nKey='BO_Booking_EnrolAnotherChild'>
					If you would like to enrol another child, please <Link to={enrolAnotherChildLink} style={{ color: '#1d93d1', fontWeight: 'bold' }}>click here</Link>.
				</Trans>
			</div>
		</div>;
	}

	render() {
		const { payment } = this.props;
		const blockUi = [PAYMENT_FETCH_REQUEST];
		const unblockUi = [PAYMENT_FETCH_SUCCESS, PAYMENT_FETCH_FAILURE];

		return <ReduxBlockUi block={blockUi} unblock={unblockUi} renderChildren={false}>
			{payment && payment.statusId === 3 && <Redirect to={`../cancelled/${payment.id}`} />}
			{(!payment || !payment.isProcessed) && this.renderMessage()}
			{payment && payment.isProcessed && this.renderPaymentDetails()}
		</ReduxBlockUi>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const { configuration, parent, entities: { payments, individualConsultations, centers, terms, grades } } = state;

	const paymentType = ownProps.location.pathname.startsWith('/individual-consultation') ? PaymentTypes.IndividualConsultation :
		ownProps.location.pathname.startsWith('/workshop') ? PaymentTypes.Workshop : PaymentTypes.Lesson;
	const paymentId = ownProps.match.params.id && Number(ownProps.match.params.id);
	const payment = paymentId && payments[paymentId];
	if (payment) {
		payment.child = getChild(parent, payment.childId);
		payment.center = payment.centerId && centers[payment.centerId];

		if (payment.lesson) {
			payment.lesson.center = centers[payment.lesson.centerId];
			payment.lesson.term = terms[payment.lesson.termId];
			payment.lesson.grade = grades[payment.lesson.gradeId];
		}
	}

	return {
		paymentType,
		payment,
		parent: parent,
		franchisor: configuration.franchisor,
		franchisorCurrency: configuration.franchisor.currency,
		routeParams: ownProps.match.params,
		...state.booking.result
	};
};

export default connect(mapStateToProps, {
	fetchPayment
})(withTranslation()(Complete));